export default "__VITE_ASSET__BlCtB4W9__"